import { useMemo } from 'react';
export const useEndIcon = ({ fetching, loading }) => {
    const endIcon = useMemo(() => (loading || fetching ? 'spinner' : undefined), [loading, fetching]);
    return endIcon;
};
